import { NoddiRadioGroup, NoddiRadioGroupProps } from '@ui-components/Inputs/NoddiRadioGroup';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props<TValue extends string | number> = Omit<
  NoddiRadioGroupProps<TValue>,
  'value' | 'onValueChange' | 'defaultValue'
>;

export const TanstackFormRadioGroup = <TValue extends string | number = string>(rest: Props<TValue>) => {
  const field = useFieldContext<TValue>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiRadioGroup
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        value={field.state.value}
        onValueChange={(value: string | number) => {
          field.handleChange(value as TValue);
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
